export default __webpack_public_path__ + "static/B0313-3ca9f977bfc2ae758e204f569b044c5d.png";